import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useTranslation } from 'react-i18next';


const Disable2FAModal = ({ onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
const { t } = useTranslation();

  const handleDisable = async () => {
    setLoading(true);
    setError('');

    try {
      const res = await api.post('/api/users/2fa/disable', { password });

      onSuccess(res.data.user);
      onClose();
    } catch (err) {
      setError(t('connexion.errorpassword'));

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
	<div className="modal-card">

      <h3>{t('2fa.desactiver')}</h3>

      <input
	className="modal-input"
        type="password"
        placeholder={t('connexion.password')}
        value={password}
        onChange={e => setPassword(e.target.value)}
      />

      {error && <p className="error">{error}</p>}
<div className="modal-actions">

      <button className="btn-primary" onClick={handleDisable} disabled={loading}>
        {t('2fa.confirmer')}
      </button>
      <button className="btn-primary" onClick={onClose}>{t('modal.annuler')}</button>
</div>
    </div>
</div>

  );
};
export default Disable2FAModal;
